import { headerService } from './Header.service';
import { orderViewModelFactory } from './OrderViewModel.factory';
import { confirmationPayloadFactory } from './ConfirmationPayload.factory';

class AppointmentService {
    async getTableInformation() {
        const session = this._parseQueryParameters()['session'];
        const serverResponse = await this._loadOrderDataFromService(session);

        const headerInformation = headerService.getAllHeaders(serverResponse);

        return orderViewModelFactory.build(serverResponse, headerInformation);
    }

    async submitOrders(displayedOrders) {
        const response = await this._sendConfirmationToService(displayedOrders);

        const statusList = response.statusList;

        const successfulOrders = statusList.filter((status) =>
            status.orderUpdateStatus
        );

        const unsuccessfulOrders = statusList.filter((status) =>
            !status.orderUpdateStatus
        );

        return {
            successfulOrders,
            unsuccessfulOrders
        };
    }

    async _sendConfirmationToService(displayedOrders) {

        const sessionKey = this._parseQueryParameters()['session'];
        const webpayload = confirmationPayloadFactory.build(displayedOrders, sessionKey);

        return fetch('/appointments/confirm', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(webpayload)
        }).then(response => response.json());
    }

    async _loadOrderDataFromService(session) {

        const result = await fetch(`/appointments?session=${session}`, {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if(result.status >= 200 && result.status <= 300) {
            //acceptable response
            return result.json();
        }
        else {
            //error somehow, we need the http status downstream so throw the entire result
            throw result;
        }
    }

    _parseQueryParameters() {
        var vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
            function(m, key, value) {
                vars[key] = value;
            });
        return vars;
    }
}

export const appointmentService = new AppointmentService();